"use client";

/**
 * Global error boundary — the last line of defense.
 *
 * app/error.tsx does NOT catch errors thrown by the root layout itself
 * (app/layout.tsx does heavy work: Clerk, analytics, fonts) or by error.tsx.
 * When that happens Next falls back to its unstyled default page unless a
 * global-error.tsx exists. This one replaces the whole document, so it must
 * render its own <html>/<body>.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#FCFAF4",
          fontFamily: "system-ui, -apple-system, sans-serif",
          color: "#1A1611",
          padding: 24,
        }}
      >
        <div style={{ maxWidth: 440, textAlign: "center" }}>
          <div style={{ fontSize: 44, marginBottom: 12 }}>⚠️</div>
          <h1 style={{ fontSize: 22, fontWeight: 700, margin: "0 0 8px" }}>Something went wrong</h1>
          <p style={{ fontSize: 14, color: "#6B6049", margin: "0 0 20px", lineHeight: 1.5 }}>
            An unexpected error occurred. Please try again. If it keeps happening, call us at{" "}
            <a href="tel:+16022289494" style={{ color: "#8A6B1E", fontWeight: 600 }}>
              (602) 228-9494
            </a>
            .
          </p>
          {error?.digest && (
            <p style={{ fontSize: 11, color: "#9A8C6E", margin: "0 0 16px" }}>Reference: {error.digest}</p>
          )}
          <button
            type="button"
            onClick={() => reset()}
            style={{
              padding: "10px 20px",
              borderRadius: 8,
              background: "#B8902E",
              color: "#1A1611",
              border: "1px solid #8A6B1E",
              fontSize: 14,
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
